import { ComponentsOverrides, Theme } from "@mui/material";
import { baseColors } from "../../../baseColors";
import { InternalThemeConfig } from "../../config";

const pagination = (config: InternalThemeConfig): ComponentsOverrides<Theme>["MuiPagination"] => {
    const { palette } = config;

    return {
        root: {
            "& .MuiPaginationItem-root": {
                fontSize: "1.6rem",
                fontWeight: "600",
                fontFamily: "RoobertCEZ",
                borderRadius: "0.8rem",
                magin: "auto",
                letterSpacing: "0.015em",

                "&.MuiPaginationItem-ellipsis": {
                    marginTop: "50%",
                    color: baseColors.grey40,
                },
                "&.Mui-selected": {
                    color: baseColors.white,
                    backgroundColor: palette.primary,
                },
                "&.MuiPaginationItem-sizeLarge": {
                    width: "4.8rem",
                    height: "4.8rem",
                },
                "&.MuiPaginationItem-sizeSmall": {
                    width: "4rem",
                    height: "4rem",
                },
                "& .MuiPaginationItem-icon": {
                    color: palette.primary,
                    fontSize: "2.4rem",
                },
            },
        },
    };
};

export default pagination;
